<template>
  <div class="main">
    <div class="row">
      <div class="col-xl-3 synops synops2">
        <div class="item">
          <span
            ><v-icon style="margin-bottom: 2px" class="ico" size="20"
              >mdi-domain</v-icon
            ></span
          >
          <span class="company-title">{{ company_name }}</span>
        </div>
        <div v-if="message" class="item">
          <span><v-icon class="ico msg">mdi-message</v-icon></span>
          <span>{{ message }}</span>
        </div>
        <div v-if="location_name" class="item">
          <span><v-icon class="ico msg">mdi-message</v-icon></span>
          <span>{{ location_name }}</span>
        </div>
      </div>
      <div class="col-xl-3 synops">
        <div class="item">
          <span
            ><v-icon style="margin-bottom: 2px" class="ico nme" size="20"
              >mdi-account-tie</v-icon
            ></span
          >
          <span class="u-name">{{ user_name }}</span>
        </div>
        <div class="item">
          <span><v-icon class="ico mail">mdi-email</v-icon></span>
          <span>{{ email }}</span>
        </div>
        <div class="item">
          <span><v-icon class="ico ph">mdi-phone</v-icon></span>
          <span>{{ phone }}</span>
        </div>
      </div>
      <div class="col-xl-2 synops synops2">
        <div
          v-if="job.legal_docs"
          :key="index"
          v-for="(doc, index) in job.legal_docs"
        >
          <div @click="viewResume(doc)" style="text-align: left; padding: 0.5rem; color: var(--button-color)">
            <span><v-icon style="color: var(--button-color)">mdi-file</v-icon></span>
            {{ doc.file_name }}
          </div>
        </div>
        <div v-if="!job.legal_docs">
          No Legal Documents Uploaded
        </div>
      </div>
      <div class="col-xl-2 but">
        <div style="text-align: right;">
          <button
            v-if="job.legal_docs"
            @click="approve()"
            class="btn btn-save-new"
          >
            Approve
          </button>
          <button
            v-else
            @click="approve(true)"
            class="btn btn-next-outline"
          >
            Override Legal Doc
          </button>
        </div>
      </div>
      <div class="col-xl-2 synops synops2 my-auto">
        <button
                @click="deleteUser"
                class="btn btn-close"
        > Delete Company
        </button>
      </div>
    </div>
    <v-dialog
      v-if="currentDocument"
      scrollable
      transition="dialog-bottom-transition"
      v-model="openBox"
      @keydown.esc="openBox = false"
    >
      <div
        style="position: relative; max-height: 80vh; width: 100%; margin: auto; overflow-y: scroll; background-color: #ffffff; padding: 2rem"
      >
        <v-icon
          @click="openBox = false"
          style="position: absolute; top: 1rem; right: 1rem"
          class="icon-class-reject"
          >mdi-close</v-icon
        >
        <div :key="change">
          <document-view
            style="width: inherit"
            v-bind:file="currentDocument"
            @close="openBox = false"
          ></document-view>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import * as FILTER from "../../../filters";
import { DOCUMENT_ACTION } from "../../../Api/common_api";
import DocumentView from "../../global-components/document-view";
export default {
  name: "job-synops",
  components: {
    DocumentView
  },
  props: {
    job: Object,
    plans: Array,
    index: Number
  },
  // validations: {
  //   plan: {required}
  // },
  data: function() {
    return {
      user_name: null,
      company_id: null,
      company_name: null,
      email: null,
      phone: null,
      message: null,
      plan: null,
      planItems: [],
      paymentStatusItems: [
        {
          text: "On-Request",
          value: 2
        },
        {
          text: "Paid",
          value: 3
        }
      ],
      planStatus: 2,
      addDiscount: false,
      discount: null,
      location_name: null,
      openBox: false,
      currentDocument: undefined,
      change: 0,
      obj_type: null
    };
  },
  methods: {
    resetDiscount() {
      this.discount = null;
      this.addDiscount = false;
    },
    approve(overirde) {
      const self = this;
      self.$emit("approve-user", self.company_id, self.index, overirde);
      // self.$v.$touch();
      // if (!self.$v.$anyError) {
      //
      // } else {
      //   alert("Please select a plan");
      // }
    },
    deleteUser() {
      const self = this;
      if (this.$route.query.q ==='new') self.obj_type=35;
      self.$emit("delete-user", self.company_id, self.index, self.obj_type);
    },
    viewResume(file) {
      const self = this;
      self.currentDocument = file;
      self.openBox = true;
      self.change++;
    }
  },
  // computed: {
  //   planErrors(){
  //     const errors = [];
  //     if (!this.$v.plan.$dirty) return errors;
  //     !this.$v.plan.required &&
  //     errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
  //     return errors;
  //   }
  // },
  mounted() {
    const self = this;
    if (self.job) {
      self.company_id = self.job.company_id;
      self.user_name = FILTER.FIRST_LETTER_CAPITAL(self.job.user_name);
      self.company_name = self.job.company_name;
      self.email = self.job.email;
      self.phone = self.job.phone;
      self.message = self.job.message || null;
      self.location_name = self.job.location_name || null;
    }
    if (self.plans.length > 0) {
      self.planItems = self.plans.sort((a, b) =>
        parseInt(a.plan_id) > parseInt(b.plan_id) ? 1 : -1
      );
    }
  }
};
</script>

<style scoped>
.main {
  background-color: #ffffff;
}
.synops {
  padding: 15px;
  cursor: pointer;
}
.synops2 {
  /*border-left: 0.4rem solid var(--button-color);*/
}
.item {
  text-align: left;
  color: #050505;
  margin: 5px;
}
.company-title {
  font-size: 16px;
}
.u-name {
  font-size: 16px;
}
.ico {
  color: #506ee4;
  margin-right: 10px;
}
.msg {
  color: var(--button-color);
}
.nme {
  color: #5867dd;
}
.mail {
  color: #8187ff;
}
.ph {
  color: #1dc9b7;
}
.but {
  margin-top: 3rem;
}
.discount {
  position: relative;
}
.dis-close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
